/**
 * Petmall — keep the Recharge subscription widget and the price block in step with the
 * selected variant.
 *
 * A sold-out variant cannot be subscribed to: the buy box swaps "Добави в количка" for
 * "Уведоми ме", and the widget has to go with it. On a subscription product the widget
 * is also what shows the price, so the standalone price block takes over whenever the
 * widget is hidden — exactly one of the two is on screen, and the price is never missing.
 *
 * The app block is not re-rendered on a variant change (re-rendering it would reset the
 * widget's own state), so Liquid sets the state the page loads with and every change
 * after that is handled here.
 */
(function () {
  const WIDGET_SELECTOR = '[data-subscription-widget]';
  const PRICE_SELECTOR = '[data-price-behind-subscription-widget]';

  /**
   * The variant the page currently shows:
   *   an object   — that variant,
   *   null        — an option combination that resolves to no variant,
   *   undefined   — nothing to go on (a product with no variant picker at all), in which
   *                 case whatever Liquid rendered is already right and is left alone.
   */
  function selectedVariant() {
    const node = document.querySelector('variant-selects [data-selected-variant]');
    if (!node) return undefined;
    if (!node.textContent.trim()) return null;
    try {
      return JSON.parse(node.textContent);
    } catch (e) {
      return undefined;
    }
  }

  function sync(variant) {
    if (variant === undefined) return;

    const widget = document.querySelector(WIDGET_SELECTOR);
    const price = document.querySelector(PRICE_SELECTOR);
    const available = !!(variant && variant.available);

    if (widget) widget.toggleAttribute('hidden', !available);
    if (price) price.toggleAttribute('hidden', available);
  }

  document.addEventListener('variant:changed', (event) => {
    const detail = event.detail || {};
    sync('variant' in detail ? detail.variant : selectedVariant());
  });

  function init() {
    sync(selectedVariant());
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
